<div class="modal-content">
    <div class="modal-header">
        <h4 id="modal-title" class="modal-title">Advanced Reorder</h4>
        <button type="button" aria-label="Close button" aria-describedby="modal-title" class="close"
            (click)="modal.dismiss()">
            <span aria-hidden="true">x</span></button>
    </div>
    <div class="modal-body">
        This item is already added to order, If you want to change the quantity you have to remove this item and add it later after the change.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Close</button>
    </div>
</div>